import React, { useCallback } from 'react';
import { HeaderTemplate, Stepper, TitleHeader } from 'web-library';
import { useHistory, useParams } from 'react-router-dom';
import RouteKey from '../../../routes/key';
import SelectConditionContent from '../../../modules/accessArrangment/components/candidate/SelectCondition/components/SelectConditionContent';

const {
  root,
  importantNotes,
  summary,
  ammendAccessArrangements,
  accessArrangementsRequest,
} = RouteKey['access-arrangement'].child;
const { accessArrangement } = RouteKey.child;

interface SelectConditionPageProps {
  routeSteps: { label: string }[];
  activeStep: number;
  title: string;
  amendment?: boolean;
}

const SelectConditionPage = ({
  routeSteps,
  activeStep,
  title,
  amendment = false,
}: SelectConditionPageProps) => {
  const history = useHistory();
  const { uuid } = useParams<{ uuid: string }>();

  const handleBack = () => {
    if (amendment) {
      history.push(`/${accessArrangement}/${root.route}/${summary.route}/${uuid}`);
    } else {
      history.push(`/${accessArrangement}/${root.route}/${importantNotes.route}`);
    }
  };

  const onSuccess = useCallback(() => {
    if (amendment) {
      history.push(`/${accessArrangement}/${root.route}/${ammendAccessArrangements.route}/${uuid}`);
    } else {
      history.push(
        `/${accessArrangement}/${root.route}/${accessArrangementsRequest.route}/${uuid}`
      );
    }
  }, [history, uuid, amendment]);

  return (
    <>
      <TitleHeader title={title} />
      <HeaderTemplate>
        <Stepper activeStep={activeStep} steps={routeSteps} />
      </HeaderTemplate>
      <SelectConditionContent handleBack={handleBack} onSuccess={onSuccess} amendment={amendment} />
    </>
  );
};
export default SelectConditionPage;
